import * as searchUtil from './search'
import * as React from 'react'

export type Search<ITEM> = {
  status: 'success' | 'request'
  search: (query: searchUtil.SearchQuery) => void
  result: searchUtil.SearchResult<ITEM>
}

export function useSearch<ITEM>(items: ITEM[], config: searchUtil.SearchConfig<ITEM>): Search<ITEM> {
  const [state, setState] = React.useState<{
    result: searchUtil.SearchResult<ITEM>
    status: 'success' | 'request'
  }>({
    status: 'request',
    result: {
      list: items,
      facets: {},
    },
  })

  return { search, result: state.result, status: state.status }

  async function search(query: searchUtil.SearchQuery): Promise<void> {
    setState((result) => ({ ...result, status: 'request' }))
    const result = await searchUtil.search(items, config, query)
    setState({ result, status: 'success' })
  }
}
